export default "__VITE_ASSET__Dk_Fswbk__"